<template>
  <div class="user-transfer-limit-modal-contain" :style="{'height': limitHight + 'px'}">
    <!-- 无效弹框 -->
    <p class="user-transfer-limit-info" v-if="isLimit">{{ isAccessApply ? $t('assessment.limitDesc2') : $t('assessment.limitDesc') }}</p>
    <p class="user-transfer-limit-info2" v-if="isLimit" ref="limitInfo">{{ factoryDesc }}</p>
    <div class="user-transfer-limit-close">
      <el-button type="primary" @click="closeLimitModal">{{$t('confirm')}}</el-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isAccessApply: {
      type: Boolean,
      default: false
    },
    limitShow: Boolean,
    isLimit: Boolean,
    factoryDesc: String
  },
  data() {
    return {
      limitHight: 40
    }
  },
  methods: {
    closeLimitModal() {
      this.$emit('closeLimitModal')
    }
  },
  mounted() {
    this.limitHight = this.$refs.limitInfo.offsetHeight + 103
  },
}
</script>

<style lang="scss">
.user-transfer-limit-modal-contain {
  .user-transfer-limit-info {
    padding: 10px 15px;
    margin: 0 !important;
  }
  .user-transfer-limit-info2 {
    padding: 10px 15px;
    margin: 0 !important;
    line-height: 16px;
    height: auto;
  }
  .user-transfer-limit-close {
    height: 43px;
    margin-top: 25px;
    .el-button {
      width: 100% !important;
      height: 100% !important;
      background-color: #1C69D3 !important;
      border: none;
      &:hover{
        background-color: #535151 !important;
      }
    }
  }
}
</style>